export default __webpack_public_path__ + "static/media/AirSAR.29508e54.jpeg";